import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { StatsDataPropertyInterface } from '../../../stats/data/property.interface';
import { Snowplow2StatsSchemaListingContextInterface } from '../schema/listing-context.interface';
import { Snowplow2StatsAdapterFurnishings } from './furnishings';
import { Snowplow2StatsAdapterPricePeriod } from './price-period';
import { Snowplow2StatsAdapterRoom } from './room';
import { Snowplow2StatsAdapterListingStatusType } from './listing-status-type';
import { Snowplow2StatsAdapterVerified } from './verified';

export class Snowplow2StatsAdapterSchemaListingContext implements StatsAdapterInterface {
  /**
   * Exclusive text
   */
  private exclusiveText: string = 'Exclusive';

  /**
   *
   * @param rawData
   * @param context
   */
  constructor(protected rawData: StatsDataPropertyInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaListingContextInterface {
    const schema: Snowplow2StatsSchemaListingContextInterface = {
      schema: 'iglu:ae.propertyfinder/listing_context/jsonschema/1-0-4',
      data: {
        web_id: this.rawData.id,
        title: this.rawData.title,
        bedrooms: 0,
        bathrooms: 0,
        price: this.rawData.price,
        location_id: this.rawData.locations[this.rawData.locations.length - 1], // take deepest location only
        broker_id: this.rawData.broker.id,
        agent_id: this.rawData.agent.id,
        area_sqft: this.rawData.size,
        offering_type: this.rawData.offeringType.toLowerCase().match(/rent$/g) === null ? 'buy' : 'rent',
        property_type_id: this.rawData.housingTypeId,
        furnishings: null,
        market: this.rawData.offeringType.toLowerCase().match(/^commercial/g) === null ? 'residential' : 'commercial',
        reference: this.rawData.referenceNumber,
        listing_status: this.rawData.listingStatus,
        quality_score: this.rawData.qs,
        verified: true,
        completion_status: this.rawData.completionStatus,
      },
    };

    // Bedrooms
    if (this.rawData.bedrooms) {
      const bedroomsAdapter = new Snowplow2StatsAdapterRoom(this.rawData.bedrooms);
      schema.data.bedrooms = bedroomsAdapter.getData();
    }

    // Bathrooms
    if (this.rawData.bathrooms) {
      const bathroomsAdapter = new Snowplow2StatsAdapterRoom(this.rawData.bathrooms);
      schema.data.bathrooms = bathroomsAdapter.getData();
    }

    // Furnishings
    if (this.rawData.furnished) {
      const furnishingsAdapter = new Snowplow2StatsAdapterFurnishings(this.rawData.furnished);
      schema.data.furnishings = furnishingsAdapter.getData();
    }

    // Price period
    if (this.rawData.rentalPeriodId) {
      const pricePerAdapter = new Snowplow2StatsAdapterPricePeriod(this.rawData.rentalPeriodId);
      schema.data.price_period = pricePerAdapter.getData();
    }

    // RERA license
    if (this.rawData.licenseRera) {
      schema.data.rera_permit_no = this.rawData.licenseRera;
    }

    // Listing status
    if (this.rawData.listingStatus) {
      const exclusiveText = this.rawData.isExclusive ? ` - ${this.exclusiveText}` : '';
      const listingStatusTypeAdapter = new Snowplow2StatsAdapterListingStatusType(this.rawData);
      schema.data.listing_status = listingStatusTypeAdapter.getData() + exclusiveText;
    }

    // Verified
    if (this.rawData.verified) {
      const verifiedAdapter = new Snowplow2StatsAdapterVerified(this.rawData.verified);
      schema.data.verified = verifiedAdapter.getData();
    }

    // Rel
    schema.data.rel = 'target';

    // Property page and property id is current property
    if (
      (this.context.global.property_page || this.context.global.property_page_offline) &&
      this.context.global.property_id === this.rawData.id
    ) {
      schema.data.rel = 'page';
    }

    // Amenities // TODO-FE[later] missing: we need backend guys to implement it

    return schema;
  }
}
